import { render, staticRenderFns } from "./TicketConnectedWithLink.vue?vue&type=template&id=68517534&scoped=true&"
import script from "./TicketConnectedWithLink.vue?vue&type=script&lang=js&"
export * from "./TicketConnectedWithLink.vue?vue&type=script&lang=js&"
import style0 from "./TicketConnectedWithLink.vue?vue&type=style&index=0&id=68517534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68517534",
  null
  
)

export default component.exports